/* global screenReaderText */
/**
 * Theme functions file.
 *
 * Contains handlers for navigation and widget area.
 */

(function ($) {
  var body,
    masthead,
    menuToggle,
    siteNavigation,
    socialNavigation,
    siteHeaderMenu,
    resizeTimer;

  function initMainNavigation(container) {
    // Add dropdown toggle that displays child menu items.
    var dropdownToggle = $("<button />", {
      class: "dropdown-toggle",
      "aria-expanded": false,
    }).append(
      $("<span />", {
        class: "screen-reader-text",
        text: screenReaderText.expand,
      })
    );

    container.find(".menu-item-has-children > a").after(dropdownToggle);

    // Toggle buttons and submenu items with active children menu items.
    container.find(".current-menu-ancestor > button").addClass("toggled-on");
    container.find(".current-menu-ancestor > .sub-menu").addClass("toggled-on");

    // Add menu items with submenus to aria-haspopup="true".
    container.find(".menu-item-has-children").attr("aria-haspopup", "true");

    container.find(".dropdown-toggle").click(function (e) {
      var _this = $(this),
        screenReaderSpan = _this.find(".screen-reader-text");

      e.preventDefault();
      _this.toggleClass("toggled-on");
      _this.next(".children, .sub-menu").toggleClass("toggled-on");

      // jscs:disable
      _this.attr(
        "aria-expanded",
        _this.attr("aria-expanded") === "false" ? "true" : "false"
      );
      // jscs:enable
      screenReaderSpan.text(
        screenReaderSpan.text() === screenReaderText.expand
          ? screenReaderText.collapse
          : screenReaderText.expand
      );
    });
  }
  initMainNavigation($(".main-navigation"));

  masthead = $("#masthead");
  menuToggle = masthead.find("#menu-toggle");
  siteHeaderMenu = masthead.find("#site-header-menu");
  siteNavigation = masthead.find("#site-navigation");
  socialNavigation = masthead.find("#social-navigation");
  var mobileDrawer = document.getElementById("mobile-drawer");
  var desktopBreakpoint = 1224;
  var drawerCloseTimer = null;
  var headerSettleTimer = null;

  function syncMobileDrawerAria() {
    if (!mobileDrawer) {
      return;
    }

    var drawerIsHidden =
      window.innerWidth < desktopBreakpoint &&
      !menuToggle.hasClass("toggled-on");
    mobileDrawer.setAttribute("aria-hidden", drawerIsHidden ? "true" : "false");
  }

  // Enable menuToggle.
  (function () {
    // Return early if menuToggle is missing.
    if (!menuToggle.length) {
      return;
    }

    // Add an initial values for the attribute.
    menuToggle
      .add(siteNavigation)
      .add(socialNavigation)
      .attr("aria-expanded", "false");
    syncMobileDrawerAria();

    function openDrawer() {
      // Snapshot scroll position and freeze the body so iOS cannot rubber-band
      // the page underneath the drawer. Restored in closeDrawer().
      var y = window.scrollY || window.pageYOffset || 0;
      document.body.dataset.scrollY = String(y);
      document.body.style.position = "fixed";
      document.body.style.top = "-" + y + "px";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
      document.body.classList.remove("mobile-nav-minified");
      document.body.classList.add("mobile-menu-open");
      if (drawerCloseTimer) {
        window.clearTimeout(drawerCloseTimer);
        drawerCloseTimer = null;
      }
      if (headerSettleTimer) {
        window.clearTimeout(headerSettleTimer);
        headerSettleTimer = null;
      }
      document.body.classList.remove("mobile-menu-settling");

      menuToggle.addClass("toggled-on");
      menuToggle.find(".container").addClass("change");
      siteHeaderMenu.addClass("toggled-on");
      if (mobileDrawer) {
        mobileDrawer.classList.add("is-open");
        mobileDrawer.scrollTop = 0;
      }
      syncMobileDrawerAria();

      menuToggle.attr("aria-expanded", "true");
      siteNavigation.attr("aria-expanded", "true");
      socialNavigation.attr("aria-expanded", "true");
    }

    function closeDrawer() {
      menuToggle.removeClass("toggled-on");
      menuToggle.find(".container").removeClass("change");
      siteHeaderMenu.removeClass("toggled-on");
      if (mobileDrawer) {
        mobileDrawer.classList.remove("is-open");
      }
      syncMobileDrawerAria();

      // Restore body scroll position. parseFloat preserves sub-pixel offsets
      // Playwright can introduce; real browsers pass integers.
      var y = parseFloat(document.body.dataset.scrollY || "0");
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      delete document.body.dataset.scrollY;

      var finishClose = function (event) {
        if (event && event.target !== mobileDrawer) {
          return;
        }

        if (event && event.propertyName !== "opacity") {
          return;
        }

        if (mobileDrawer) {
          mobileDrawer.removeEventListener("transitionend", finishClose);
        }

        if (drawerCloseTimer) {
          window.clearTimeout(drawerCloseTimer);
          drawerCloseTimer = null;
        }

        if (menuToggle.hasClass("toggled-on")) {
          return;
        }

        document.body.classList.add("mobile-menu-settling");
        document.body.classList.remove("mobile-menu-open");
        if (window.innerWidth < desktopBreakpoint && y > 20) {
          document.body.classList.add("mobile-nav-minified");
        }
        if (headerSettleTimer) {
          window.clearTimeout(headerSettleTimer);
        }
        headerSettleTimer = window.setTimeout(function () {
          document.body.classList.remove("mobile-menu-settling");
          headerSettleTimer = null;
        }, 120);
      };

      if (mobileDrawer) {
        mobileDrawer.addEventListener("transitionend", finishClose);
        drawerCloseTimer = window.setTimeout(finishClose, 320);
      } else {
        finishClose();
      }

      // Scroll in a double-rAF after the style changes have been committed.
      // Without this the browser may clamp the scroll because documentElement
      // scrollHeight has not yet re-expanded. We force `behavior: 'instant'`
      // to bypass the global `html { scroll-behavior: smooth }` rule — without
      // it the page animates back to the saved offset, which both looks bad
      // and leaves `scrollY` wrong for any sync code running after close().
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          try {
            window.scrollTo({ top: y, left: 0, behavior: "instant" });
          } catch (e) {
            // Safari <15.4 does not accept behavior: 'instant' — fall back.
            window.scrollTo(0, y);
          }
        });
      });

      menuToggle.attr("aria-expanded", "false");
      siteNavigation.attr("aria-expanded", "false");
      socialNavigation.attr("aria-expanded", "false");
    }

    // Expose close for other handlers (Escape, resize).
    menuToggle.data("closeDrawer", closeDrawer);

    menuToggle.on("click.bmtg", function () {
      if (menuToggle.hasClass("toggled-on")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    // Close mobile menu on Escape and return focus to the toggle button.
    $(document).on("keydown.bmtg-escape", function (e) {
      if (e.key === "Escape" && menuToggle.hasClass("toggled-on")) {
        menuToggle.trigger("click");
        menuToggle.trigger("focus");
      }
    });

    // Close the drawer when the viewport crosses into the desktop breakpoint
    // while the menu is open. We go through closeDrawer() — not just a class
    // strip — so the body-freeze scroll lock is properly undone. Debounced
    // with a rAF coalesce so a burst of resize events only runs the check
    // once per frame.
    var resizeClosePending = false;
    $(window).on("resize.bmtg-close", function () {
      if (resizeClosePending) {
        return;
      }
      resizeClosePending = true;
      window.requestAnimationFrame(function () {
        resizeClosePending = false;
        if (
          window.innerWidth >= desktopBreakpoint &&
          menuToggle.hasClass("toggled-on")
        ) {
          closeDrawer();
        }
      });
    });

    // Focus management for the mobile drawer (Step 5).
    var focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getDrawerFocusables() {
      var inner = siteHeaderMenu.find(focusableSelector).filter(":visible");
      // Include the toggle button at the start so it participates in the trap.
      return menuToggle.add(inner);
    }

    // On open, move focus to the first focusable element inside the drawer.
    // Anchor the focus shift to the drawer's opacity `transitionend` so we
    // land focus exactly when the content is fully visible — not 50ms after
    // the click, which was unreliable on slow devices. If the user has
    // prefers-reduced-motion (no transition), fall back to a double rAF so
    // layout has settled before we measure/focus.
    var reducedMotionMQ = window.matchMedia
      ? window.matchMedia("(prefers-reduced-motion: reduce)")
      : { matches: false };

    function focusFirstInDrawer() {
      var focusables = siteHeaderMenu
        .find(focusableSelector)
        .filter(":visible");
      if (focusables.length) {
        focusables.first().trigger("focus");
      }
    }

    menuToggle.on("click.bmtg-focus", function () {
      if (!menuToggle.hasClass("toggled-on") || !mobileDrawer) {
        return;
      }

      if (reducedMotionMQ.matches) {
        // No transition will fire — schedule after two frames so layout is
        // settled (stylesheet application + any deferred reflow).
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(focusFirstInDrawer);
        });
        return;
      }

      // One-shot listener: only care about the opacity track (transform and
      // visibility also fire transitionend, and we want the focus move
      // anchored to the visual fade-in, not the translate).
      var onEnd = function (e) {
        if (e.propertyName !== "opacity") {
          return;
        }
        mobileDrawer.removeEventListener("transitionend", onEnd);
        focusFirstInDrawer();
      };
      mobileDrawer.addEventListener("transitionend", onEnd);
    });

    // Focus trap: wrap Tab / Shift+Tab at drawer boundaries.
    $(document).on("keydown.bmtg-focus-trap", function (e) {
      if (e.key !== "Tab" || !menuToggle.hasClass("toggled-on")) {
        return;
      }

      var focusables = getDrawerFocusables();
      if (focusables.length < 2) {
        return;
      }

      var first = focusables.first()[0];
      var last = focusables.last()[0];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        focusables.last().trigger("focus");
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        focusables.first().trigger("focus");
      }
    });
  })();

  // Fix sub-menus for touch devices and better focus for hidden submenu items for accessibility.
  (function () {
    if (!siteNavigation.length || !siteNavigation.children().length) {
      return;
    }

    // Toggle `focus` class to allow submenu access on tablets.
    function toggleFocusClassTouchScreen() {
      if (window.innerWidth >= 910) {
        $(document.body).on("touchstart.bmtg", function (e) {
          if (!$(e.target).closest(".main-navigation li").length) {
            $(".main-navigation li").removeClass("focus");
          }
        });
        siteNavigation
          .find(".menu-item-has-children > a")
          .on("touchstart.bmtg", function (e) {
            var el = $(this).parent("li");

            if (!el.hasClass("focus")) {
              e.preventDefault();
              el.toggleClass("focus");
              el.siblings(".focus").removeClass("focus");
            }
          });
      } else {
        siteNavigation
          .find(".menu-item-has-children > a")
          .unbind("touchstart.bmtg");
      }
    }

    if ("ontouchstart" in window) {
      $(window).on("resize.bmtg", toggleFocusClassTouchScreen);
      toggleFocusClassTouchScreen();
    }

    siteNavigation.find("a").on("focus.bmtg blur.bmtg", function () {
      $(this).parents(".menu-item").toggleClass("focus");
      $(".main-navigation").toggleClass("focus");
    });
  })();

  // Add the default ARIA attributes for the menu toggle and the navigations.
  function onResizeARIA() {
    syncMobileDrawerAria();
    if (window.innerWidth < desktopBreakpoint) {
      if (menuToggle.hasClass("toggled-on")) {
        menuToggle.attr("aria-expanded", "true");
      } else {
        menuToggle.attr("aria-expanded", "false");
      }

      if (siteHeaderMenu.hasClass("toggled-on")) {
        siteNavigation.attr("aria-expanded", "true");
        socialNavigation.attr("aria-expanded", "true");
      } else {
        siteNavigation.attr("aria-expanded", "false");
        socialNavigation.attr("aria-expanded", "false");
      }

      menuToggle.attr("aria-controls", "site-navigation social-navigation");
    } else {
      menuToggle.removeAttr("aria-expanded");
      siteNavigation.removeAttr("aria-expanded");
      socialNavigation.removeAttr("aria-expanded");
      menuToggle.removeAttr("aria-controls");
    }
  }

  // Add 'below-entry-meta' class to elements.
  function belowEntryMetaClass(param) {
    if (
      body.hasClass("page") ||
      body.hasClass("search") ||
      body.hasClass("single-attachment") ||
      body.hasClass("error404")
    ) {
      return;
    }

    $(".entry-content")
      .find(param)
      .each(function () {
        var element = $(this),
          elementPos = element.offset(),
          elementPosTop = elementPos.top,
          entryFooter = element.closest("article").find(".entry-footer"),
          entryFooterPos = entryFooter.offset(),
          entryFooterPosBottom =
            entryFooterPos.top + (entryFooter.height() + 28),
          caption = element.closest("figure"),
          figcaption = element.next("figcaption"),
          newImg;

        // Add 'below-entry-meta' to elements below the entry meta.
        if (elementPosTop > entryFooterPosBottom) {
          // Check if full-size images and captions are larger than or equal to 840px.
          if ("img.size-full" === param || ".wp-block-image img" === param) {
            // Create an image to find native image width of resized images (i.e. max-width: 100%).
            newImg = new Image();
            newImg.src = element.attr("src");

            $(newImg).on("load.bmtg", function () {
              if (newImg.width >= 840) {
                // Check if an image in an image block has a width attribute; if its value is less than 840, return.
                if (
                  ".wp-block-image img" === param &&
                  element.is("[width]") &&
                  element.attr("width") < 840
                ) {
                  return;
                }

                element.addClass("below-entry-meta");

                if (caption.hasClass("wp-caption")) {
                  caption.addClass("below-entry-meta");
                  caption.removeAttr("style");
                }

                if (figcaption) {
                  figcaption.addClass("below-entry-meta");
                }
              }
            });
          } else {
            element.addClass("below-entry-meta");
          }
        } else {
          element.removeClass("below-entry-meta");
          caption.removeClass("below-entry-meta");
        }
      });
  }

  $(document).ready(function () {
    body = $(document.body);

    $(window)
      .on("load.bmtg", onResizeARIA)
      .on("resize.bmtg", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          belowEntryMetaClass("img.size-full");
          belowEntryMetaClass("blockquote.alignleft, blockquote.alignright");
          belowEntryMetaClass(".wp-block-image img");
        }, 300);
        onResizeARIA();
      });

    belowEntryMetaClass("img.size-full");
    belowEntryMetaClass("blockquote.alignleft, blockquote.alignright");
    belowEntryMetaClass(".wp-block-image img");
  });
})(jQuery);
